<div
  class="chart-table-holder"
  style="overflow: auto; max-height: 300px; height: 100%;"
>
  <div *ngIf="!loading && !showError">
    <nz-table
      [nzData]="chartDataTable"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      [nzScroll]="{ x: 'auto' }"
      [nzBordered]="true"
    >
      <thead>
        <tr>
          <th
            nzLeft
            class="make-sticky"
            [ngClass]="{ 'bold-header': titleHeader !== '' }"
          >
            {{ titleHeader }}
          </th>
          <th
            [ngClass]="{
              'bold-header':
                chartType !== 'revision-daily' &&
                chartType !== 'revision-monthly' &&
                chartType !== 'revision-dailypeers' &&
                chartType !== 'revision-monthlypeers'
            }"
            *ngFor="let header of headers"
          >
            {{ header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of chartDataTable; index as i">
          <td
            nzLeft
            class="make-sticky"
            [ngClass]="{
              'bold-header':
                chartType === 'revision-daily' ||
                chartType === 'revision-monthly' ||
                chartType === 'revision-dailypeers' ||
                chartType === 'revision-monthlypeers'
            }"
          >
            {{ rowHeader[i] }}
          </td>
          <td *ngFor="let data of row">
            <span *ngIf="data.class === 'error-color'" class="error-color"
              >( {{ data.value | number: precision }} )</span
            >
            <span *ngIf="data.class !== 'error-color'">
              {{
                data.value !== null && data.value !== null
                  ? (data.value | number: precision)
                  : ""
              }}
            </span>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
  <ul *ngIf="loading">
    <li *ngFor="let dummySection of [0, 1, 2]">
      <nz-skeleton
        [nzTitle]="true"
        [nzActive]="true"
        [nzParagraph]="false"
      ></nz-skeleton>
    </li>
  </ul>
  <div id="charts-error" class="error-container" *ngIf="showError">
    <div class="error-msg">
      <va-icon name="info-circle" class="info-icon"></va-icon>
      <span class="error-text">{{
        errorMessage ? errorMessage : "Something went wrong"
      }}</span>
    </div>
  </div>
</div>
